<mat-toolbar class="topbar mat-bg-card">
  @if (layoutConf.sidebarStyle !== 'compact'&&!jwtAuth.isDriver()) {
  <button mat-icon-button id="sidenavToggle" (click)="toggleSidenav()">
    <mat-icon>menu</mat-icon>
  </button>
  } @if (jwtAuth.isDriver()) {
  <div
    class="branding"
    routerLink="/driver/delivery_pickup"
    style="
      height: 100% !important;
      position: static !important;
      width: auto !important;
      flex-wrap: wrap;
      line-height: 1;
      padding: 2px;
    "
  >
    <img [src]="logo" alt="" class="app-logo" />
    <p style="font-size: smaller" class="mm-text-accent">Driver</p>
  </div>
  } @if ( jwtAuth.isAdmin() || jwtAuth.isPharmacyUser() || jwtAuth.isBusiness()) {
  <div class="search-bar">
    <div class="top-search-form">
      @if (!loading) {
      <mat-icon class="icon-in-bar">search</mat-icon>
      } @else {
      <mat-icon class="icon-in-bar icon-in-bar--loader"
        ><mat-spinner diameter="17"></mat-spinner
      ></mat-icon>
      }
      <input
        (focus)="focused = true"
        (blur)="focused = false"
        #searchInput
        [formControl]="searchTermControl"
        [matAutocomplete]="searchOrdersInput"
        type="text"
      />
      <mat-autocomplete
        [displayWith]="null"
        (optionSelected)="selectHandler($event)"
        #searchOrdersInput="matAutocomplete"
      >
        @for (order of searchOrderResults; track order) {
        <mat-option>
          <div
            [routerLink]="['orders/vieworders/' + order.orderId]"
            class="search-orders-result"
          >
            <b
              [ngClass]="{
              'mm-text-green': order.paymentStatus == 1,
              'mm-text-pink': order.paymentStatus != 1
            }"
              class="mr-2"
              >{{ order.paymentStatus == 1 ? 'P' : 'NP' }}</b
            >
            <b class="mr-2">${{ order.orderTotal }}</b>
            <span class="mr-2">#{{ order.uniqueOrderId }}</span>
            <span fxFlex="1 1 auto">
              <span>{{ order.firstName }}</span>
              @if (order.lastName) {
              <span class="ml-2">{{ order.lastName }}</span>
              }
            </span>
            <span>{{ order.created_At | date:'ccc MMM yy'}}</span>
          </div>
        </mat-option>
        }
      </mat-autocomplete>
      @if (shouldDisplayNoResultsMessage()) {
      <div class="no-search-results">
        <div class="no-search-results-inner">
          <mat-icon class="no-search-results-icon">search</mat-icon>
          <b>No search results found</b>
          <div>Please try again with a different search type</div>
        </div>
      </div>
      }
    </div>
  </div>
  } @if (jwtAuth.isClinician()) {
  <div
    fxLayout="row"
    fxLayoutAlign="space-between center"
    fxLayoutGap="16px"
    style="width: 100%"
  >
    <div
      fxLayout="row"
      fxLayoutAlign="start center"
      fxFlex="auto"
      class="mm-ml-2"
      fxLayoutGap="16px"
    >
      <div fxLayout="row" fxLayoutGap="8px">
        @if (username && password) {
        <div fxLayout="row" fxLayoutGap="8px">
          <button
            mat-stroked-button
            class="mm-text-black"
            fxLayout="row"
            fxLayoutAlign="space-between center"
          >
            User: {{username}}
            <button mat-icon-button (click)="copyToClipboard(username, 'User Name')">
              <mat-icon>content_copy</mat-icon>
            </button>
          </button>
          <button
            mat-stroked-button
            class="mm-text-black"
            fxLayout="row"
            fxLayoutAlign="space-between center"
          >
            Password: {{password}}
            <button mat-icon-button (click)="copyToClipboard(password, 'Password')">
              <mat-icon>content_copy</mat-icon>
            </button>
          </button>
        </div>
        } @if (!username && !password && shiftStatus !== 'assigned' && shiftStatus !==
        'no_shift') {
        <div>
          <button mat-stroked-button class="mm-error mm-text-pink">
            No logins Available Please Contact Support
          </button>
        </div>
        }
      </div>
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
        <button mat-stroked-button (click)="refreshPage()" class="mm-bg-orange mm-text-white">
          Refresh
        </button>
        @if (isShiftAvailable) {
        <div>
          <button mat-stroked-button class="mm-text-black">{{isShiftAvailable}}</button>
        </div>
        }
        <app-shift-button
          (remoteDesktopCredentials)="handleRemoteDesktopCredentials($event)"
          class="mm-pr-4"
          (shiftAvailabilityChange)="isShiftAvailable = $event"
          [disableShiftActions]="jwtAuth.getIsDemoUserView()"
        ></app-shift-button>
        @if (jwtAuth.getIsDemoUserView()) {
        <div>
          <button color="accent" mat-stroked-button (click)="switchToAdminView()">
            Switch to Admin View
          </button>
        </div>
        }
      </div>
    </div>
  </div>
  }

  <div class="d-flex topbar-actions">
    @if (jwtAuth.isAdmin()) {
    <button
      mat-stroked-button
      (click)="triggerOrdersAutoAllocation()"
      [disabled]="isProcessing || jwtAuth.getIsDemoUserView()"
    >
      @if (!isProcessing) {
      <span>Auto Allocate Orders</span>
      } @if (isProcessing) {
      <span>Processing...</span>
      }
    </button>
    } @if (!jwtAuth.isClinician()) {
    <button
      mat-icon-button
      disableRipple
      matTooltip="Need Help?"
      [routerLink]="jwtAuth.isDriver()?'/driver/support':'/support'"
      class="topbar-button-right img-button"
    >
      <mat-icon>help</mat-icon>
      <span>Help</span>
    </button>
    }

    <button
      mat-icon-button
      disableRipple
      [matMenuTriggerFor]="accountMenu"
      class="topbar-button-right img-button"
    >
      <mat-icon>account_circle</mat-icon>
      <div>{{ getUserDisplayName() }}</div>
    </button>
  </div>

  <mat-menu #accountMenu="matMenu">
    <button mat-menu-item (click)="openTwoFactorAuth()">
      <mat-icon>settings</mat-icon>
      <span>Two-factor authentication</span>
    </button>
    <button mat-menu-item (click)="jwtAuth.signout()" [disabled]="jwtAuth.getIsDemoUserView()">
      <mat-icon>exit_to_app</mat-icon>
      <span>{{ "SIGNOUT" | translate }}</span>
    </button>
  </mat-menu>
</mat-toolbar>
